export default function IsometricDots() {
  return (
    <>
      <clipPath id="a">
        <path d="m0 0h48v48h-48z" />
      </clipPath>
      <mask id="b" height="48" maskUnits="userSpaceOnUse" width="48" x="0" y="0">
        <path d="m0 0h48v48h-48z" fill="#fff" />
      </mask>
      <mask id="c" height="24" maskUnits="userSpaceOnUse" width="48" x="0" y="0">
        <path d="m0 0h48v24h-48z" fill="#fff" />
      </mask>
      <mask id="d" height="24" maskUnits="userSpaceOnUse" width="48" x="0" y="24">
        <path d="m0 24h48v24h-48z" fill="#fff" />
      </mask>
      <g clipPath="url(#a)">
        <g mask="url(#b)">
          <g fill="#140d30" opacity=".2">
            <g mask="url(#c)">
              <path d="m24 25c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z" />
              <path d="m24 1c.5523 0 1-.447715 1-1s-.4477-1-1-1-1 .447715-1 1 .4477 1 1 1z" />
              <path d="m0 13c.552285 0 1-.4477 1-1s-.447715-1-1-1-1 .4477-1 1 .447715 1 1 1z" />
              <path d="m48 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z" />
            </g>
            <g mask="url(#d)">
              <path d="m24 49c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z" />
              <path d="m24 25c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z" />
              <path d="m0 37c.552285 0 1-.4477 1-1s-.447715-1-1-1-1 .4477-1 1 .447715 1 1 1z" />
              <path d="m48 37c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z" />
            </g>
          </g>
        </g>
      </g>
    </>
  );
}
